import { render, staticRenderFns } from "./ship.vue?vue&type=template&id=155f2262&"
import script from "./ship.vue?vue&type=script&lang=js&"
export * from "./ship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src271809469/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155f2262')) {
      api.createRecord('155f2262', component.options)
    } else {
      api.reload('155f2262', component.options)
    }
    module.hot.accept("./ship.vue?vue&type=template&id=155f2262&", function () {
      api.rerender('155f2262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ship/ship.vue"
export default component.exports